<div style="text-align: center;">
  <div style="font-size:36px;font-weight:600;">
    <adp-label labelKey="Deductible_Lookup_Device_Header"></adp-label>
  </div>
</div>

<div class="mt-30 mb-30 container deductible-lookup-page" style="color:#13223C;">

  <div class="column image-col">
    <adp-image class="deductible-image" imageKey="Global_Deductible_Lookup_Image"></adp-image>
  </div>

  <form [formGroup]='deductibleLookupForm' (ngSubmit)="handleFormSubmitted()">
    <div class="column text-column">
      <div style="font-size:24px;font-weight:600;">
        <adp-label labelKey="Deductible_Lookup_Device_Title"></adp-label>
      </div>

      <div style="font-size:18px;font-weight:400;">
        <adp-label labelKey="Deductible_Lookup_Device_Subtitle"></adp-label>
      </div>

      <div class="mt-30 deductible-select">
        <adp-select [resourceData]="getResource('Deductible_Lookup_Device_Types')" formControlName="deviceTypesSelect"
          [sf-aria-label]="'Account_Communication_Preferences_Language_Subheading'" (selectionChange)="getMakes()"
          [listItems]="deviceTypes"></adp-select>
      </div>

      <div class="deductible-select" *ngIf="makes">
        <adp-select [resourceData]="getResource('Deductible_Lookup_Device_Makes')" formControlName="makesSelect"
          [sf-aria-label]="'Account_Communication_Preferences_Language_Subheading'" (selectionChange)="getModels()"
          [listItems]="makes"></adp-select>
      </div>

      <div class="deductible-select" *ngIf="models">
        <adp-select [resourceData]="getResource('Deductible_Lookup_Device_Models')" formControlName="modelsSelect"
          [sf-aria-label]="'Account_Communication_Preferences_Language_Subheading'" [listItems]="models"></adp-select>
      </div>

      <div class="mt-20 deductible-submit">
        <button mat-flat-button color='accent' type="submit"
          [ngStyle]="{display: deductibleLookupForm.valid ? 'block' : 'none'}" [gtmClick]="getViewLabel('Deductible_Lookup_Device_Button')">
          <adp-label [labelKey]="'Deductible_Lookup_Device_Button'"></adp-label>
        </button>
      </div>

    </div>
  </form>

</div>
